export default "__VITE_ASSET__H2RS1e60__"